import _ from 'lodash'
import { actions } from '../features/Settings'
import { actions as loadingBarActions } from '../features/LoadingBar'
import { SERVERS_UPDATE_SERVERLIST, SERVERS_UPDATE_ACTIVE } from '../constants'

const ServerMiddleware = store => next => (action) => {
    switch (action.type) {
        case SERVERS_UPDATE_SERVERLIST: {
            const result = next(action)
            const list = store.getState().servers.list
            if (_.size(list) > 0) {
                const servers = _.mapValues(list, v => v.name)
                store.dispatch(actions.setServers(servers))
            }
            return result
        }

        case SERVERS_UPDATE_ACTIVE: {
            const result = next(action)
            let name = ''
            let shortName = ''
            // TODO: Need to get the servers via selectors instead of directly from state!!!1
            const state = store.getState().servers
            if (state.active != null && state.active !== '') {
                shortName = state.active
                try {
                    name = state.list[state.active].name
                } catch (e) {
                    name = ''
                }
            }
            store.dispatch(loadingBarActions.setServerName(name, shortName))
            return result
        }

        default:
            return next(action)
    }
}

export default ServerMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/ServerMiddleware.js